import { defineStore } from 'pinia'

export const useCommandContextStore = defineStore('commandContext', {
  state: () => ({
    projectID: null as string | null,
    tags: [] as string[],
    mediaFolderID: null as string | null,
  }),
  actions: {
    setProject(id: string | null) {
      this.projectID = id
    },
    setTags(tags: string[]) {
      this.tags = tags
    },
    setMediaFolder(id: string | null) {
      this.mediaFolderID = id
    },
    reset() {
      this.projectID = null
      this.tags = []
      this.mediaFolderID = null
    },
  },
})
